import { API_SERVICES } from "@packages/api/types";

export default {
    API_SERVICE: API_SERVICES.INTEGRATION,

    url(path = "") {
        return `${this.API_SERVICE}${this.apiUrl}${path}`;
    },

    userUrl({ path = "" } = {}) {
        return `${this.API_SERVICE}/account${this.apiUrl}${path}`;
    },

    adminUrl(path = "") {
        return `${this.API_SERVICE}${this.urlAdmin}${path}`;
    }
};
